import React, { lazy } from 'react';
import { ProtectedRoute } from '@components';

const Salary = lazy(() => import('./salary'));

export default {
  path: 'salary',
  element: <ProtectedRoute title="工资条" component={<Salary />} />,
};
